import { render, staticRenderFns } from "./CnpjMatrizField.vue?vue&type=template&id=7f45ae9d&scoped=true&"
import script from "./CnpjMatrizField.vue?vue&type=script&lang=js&"
export * from "./CnpjMatrizField.vue?vue&type=script&lang=js&"
import style0 from "./CnpjMatrizField.vue?vue&type=style&index=0&id=7f45ae9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45ae9d",
  null
  
)

export default component.exports